import React, { useEffect, createElement } from 'react';
import { Header } from './components/Header';
import { PersonalStory } from './components/PersonalStory';
import { ProductIntro } from './components/ProductIntro';
import { Benefits } from './components/Benefits';
import { Ingredients } from './components/Ingredients';
import { Testimonials } from './components/Testimonials';
import { SpecialOffer } from './components/SpecialOffer';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { ExitIntentPopup } from './components/ExitIntentPopup';
import { MetaPixel } from './components/MetaPixel';
// Set document title immediately to prevent flash of other titles
if (typeof document !== 'undefined') {
  document.title = 'Brainy Decidely - Naturligt kosttillskott för hjärnhälsa';
}
export function App() {
  useEffect(() => {
    // Ensure title is set again in useEffect for consistency
    document.title = 'Brainy Decidely - Naturligt kosttillskott för hjärnhälsa';
    // Add custom animation for slow pulsing
    const style = document.createElement('style');
    style.textContent = `
      @keyframes pulse-slow {
        0%, 100% {
          transform: scale(1);
          opacity: 1;
        }
        50% {
          transform: scale(1.03);
          opacity: 0.9;
        }
      }
      .animate-pulse-slow {
        animation: pulse-slow 3s infinite ease-in-out;
      }
    `;
    document.head.appendChild(style);
  }, []);
  return <div className="font-sans text-gray-800 bg-amber-50" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <ExitIntentPopup data-id="element-2" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-3">
        <Header data-id="element-4" />
        <main data-id="element-5">
          <PersonalStory data-id="element-6" />
          <ProductIntro data-id="element-7" />
          <Benefits data-id="element-8" />
          <Ingredients data-id="element-9" />
          <Testimonials data-id="element-10" />
          <SpecialOffer data-id="element-11" />
          <FAQ data-id="element-12" />
        </main>
        <Footer data-id="element-13" />
      </div>
    </div>;
}